export const defaultUiPosition = {x: 100, y: -100}
